import { AxiosInstance } from "axios"

import { exportReportApi } from "api/emailCommunication/exportReportApi"
import { forwardEmailApi } from "api/emailCommunication/forwardEmailApi"
import { getEmailLogDetailApi } from "api/emailCommunication/getEmailLogDetailApi"
import { getPaginatedEmailCommunicationDetailApi } from "api/emailCommunication/getPaginatedEmailCommunicationApi"
import { getPaginatedLogDetailApi } from "api/emailCommunication/getPaginatedEmailLogApi"
import defaultAxiosInstance from "services/client"

export class ManageTokenClient {
  private axiosInstance: AxiosInstance

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance
  }

  // --------- Email Communication module APIs ---------
  getPaginatedLogDetail(
    request: Parameters<typeof getPaginatedEmailCommunicationDetailApi>[0],
  ) {
    return getPaginatedLogDetailApi(request, this.axiosInstance)
  }

  getEmailLogDetail(request: Parameters<typeof getEmailLogDetailApi>[0]) {
    return getEmailLogDetailApi(request, this.axiosInstance)
  }

  forwardEmail(request: Parameters<typeof forwardEmailApi>[0]) {
    return forwardEmailApi(request, this.axiosInstance)
  }

  exportReportDownloadApi(request: Parameters<typeof exportReportApi>[0]) {
    return exportReportApi(request, this.axiosInstance)
  }
}

export const systemEmailLogClient = new ManageTokenClient(defaultAxiosInstance)
